// theme.js
import { createTheme } from '@mui/material/styles';

const baseTheme = createTheme({
  
  components: {
    // ======================================================
      // -- SELECTOR (Select + FormControl) --
    // ====================================================== 
    MuiFormControl: {
      styleOverrides: {
        root: {
           // Contenedor general de select/form control: ancho completo y reset de márgenes/paddings.
           width: '100%',
          // marginTop: '-0.6vh', paddingTop: '0.2vh',
          margin: '0', padding: '0',
          color: 'rgba(255,255,255,0.78)',
          // Selector interno que apunta al contenido textual del Select (el valor visible).
          '& .MuiSelect-select': {
            fontSize: '.8vw',
            textAlign: 'center',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          textAlign: 'center',
          color: 'rgba(255,255,255,0.78)',
          fontSize: '.8vw',
          height: '4.5vh',
          margin: '0vh',
          /* Inactivo */
          '& .MuiOutlinedInput-notchedOutline': {
            //borderColor: 'rgba(233, 78, 26, .3)',
            borderColor: 'var(--border-color-opacity-dark)'// p.ej. rgba(…,.3)
          },
          /* Hover */
          '&:hover .MuiOutlinedInput-notchedOutline': {
            //borderColor: 'rgba(233, 78, 26, .7)',
            borderColor: 'var(--border-color-opacity-medium)',  // p.ej. rgba(…,.7)
          },
          /* Seleccionado */
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            //borderColor: 'rgba(233, 78, 26, .9)',
            borderColor: 'var(--border-color-opacity-light)',
          },
          // Ícono del select (flecha) — solo coloreado si no está deshabilitado.
          '& .MuiSelect-icon:not(.Mui-disabled)': {
            //color: '#e94e1a',
            color: 'var(--border-color-opacity-light)',
          },
          
          // ==== ESTADOS DESHABILITADOS ====
          // Valor o placeholder visible cuando el select está deshabilitado.
          '&.Mui-disabled .MuiSelect-select': {
            color: 'rgba(166,166,166,0.4)',
            WebkitTextFillColor: 'rgba(166,166,166,0.4)', // para compatibilidad con algunos navegadores
          },
          '&.Mui-disabled .MuiSelect-icon': {
            //color: 'rgba(233, 78, 26, .1)',
            color: 'var(--border-color-opacity-disabled)', // p.ej. rgba(…,.15)
          }
        },
      },
      defaultProps: {
        variant: 'outlined',
        fullWidth: true,
        // === Props por defecto del menú desplegable ===
        MenuProps: {
          PaperProps: {
            sx: {
              backgroundColor: 'rgba(28,28,28)', // fondo del dropdown
              maxHeight: '35vh', // altura máxima
              fontSize: '.1vh', // tamaño base (puede ajustarse si se quiere más pequeño)
              '& .MuiMenuItem-root': {
                // Estilo de cada item dentro del menú
                fontSize: '1.6vh',
                color: 'rgba(255,255,255,0.78)',
                letterSpacing: '1.4',
                '&:hover': {
                  backgroundColor: '#303030', // hover normal de item
                },
                '&.Mui-selected': {
                  // item seleccionado
                  //backgroundColor: 'rgba(233, 78, 26, .05)',
                  backgroundColor: 'var(--border-color-opacity-lighter)', // p.ej. rgba(…,.05)
                  '&:hover': {
                    //backgroundColor: 'rgba(233, 78, 26, .1)', // hover cuando ya está seleccionado
                    backgroundColor: 'var(--border-color-opacity-disabled)', // p.ej. rgba(…,.15)
                  },
                },
              },
            },
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          // Fondo y hover global para items (complementa lo definido en MenuProps)
          backgroundColor: 'rgba(28,28,28)',//'#252525',
          '&:hover': {
            backgroundColor: '#303030', // 'rgba(150,150,150,0.9)',
          },
          // Si dentro del MenuItem hay un input (raramente), aseguramos que su texto esté centrado
          '& input': {
            textAlign: 'center',
          },
        },
      },
    },

    // ======================================================
      // -- INPUT LABEL (labels flotantes y placeholders) --
    // ====================================================== 
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '1.5vh',
          color: 'rgb(112, 112, 112)',
    
          // Posicionamiento inicial (cuando no está "shrunken")
          transform: 'translate(14px, 12px) scale(1)',
    
          // Cuando tiene valor o está enfocado: flota arriba y reduce tamaño
          '&.MuiInputLabel-shrink': {
            transform: 'translate(14px, -8px) scale(0.75)',
            //color: '#a6a6a6',
            color: 'rgb(112, 112, 112)',
          },
    
          // Fuerza color en foco
          '&.Mui-focused': {
            //color: '#a6a6a6',
            color: 'rgb(112, 112, 112)',
          },
          // Color cuando está disabled explícitamente
          '&.Mui-disabled': {
            color: 'rgba(166, 166, 166, 0.4)',
          },
          // Caso donde el padre está deshabilitado pero la label no recibió la clase directamente.
          // Esto aplica si un ancestro tiene .Mui-disabled y el label está adentro.
          '.Mui-disabled &': {
            color: 'rgba(166, 166, 166, 0.4)',
          },
        },
      },
    },

    // ======================================================
      // -- TEXTFIELD / OUTLINED INPUT --
    // ====================================================== 
    MuiOutlinedInput: { // equivalente a <TextField variant="outlined">
      styleOverrides: {
        root: {
          fontSize: '1.5vh',
          color: '#a6a6a6',
          height: '4.5vh',
          maxHeight: '4.5vh',
          minHeight: '4.5vh',

          // === BORDES ===
          /* '& fieldset': {
            //borderColor: 'rgba(233, 78, 26, .3)',
            borderColor: 'var(--border-color-opacity-light)',   // p.ej. rgba(…,.3)
          },
          '&:hover fieldset': {
            //borderColor: 'rgba(233, 78, 26, .7)',
            borderColor: 'var(--border-color-opacity-medium)',  // p.ej. rgba(…,.7)
          },
          '&.Mui-focused fieldset': {
            //borderColor: 'rgba(233, 78, 26, .9)',
            borderColor: 'var(--border-color-opacity-light)',
          }, */
          
          /* Inactivo */
          '& .MuiOutlinedInput-notchedOutline': {
            //borderColor: 'rgba(233, 78, 26, .3)', // default
            borderColor: 'var(--border-color-opacity-dark)'// p.ej. rgba(…,.3)
          },
          /* Hover */
          '&:hover .MuiOutlinedInput-notchedOutline': {
            //borderColor: 'rgba(233, 78, 26, .7)', // hover
            borderColor: 'var(--border-color-opacity-medium)',  // p.ej. rgba(…,.7)
          },
          /* Seleccionado */
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            //borderColor: 'rgba(233, 78, 26, .9)', // focus
            borderColor: 'var(--border-color-opacity-light)',
          },
          '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
            //borderColor: 'rgba(233, 78, 26, .15)', // disabled
            borderColor: 'var(--border-color-opacity-disabled)'// p.ej. rgba(…,.15)
          },

          // === TEXTO EN DESHABILITADO ===
          '&.Mui-disabled': {
            color: 'rgba(166, 166, 166, 0.4)', // color del texto heredado si aplica
          },
          '&.Mui-disabled .MuiOutlinedInput-input': {
            // Apunta directamente al input interno para asegurar que el texto también se tiña
            color: 'rgba(166, 166, 166, 0.4)',
            WebkitTextFillColor: 'rgba(166,166,166,0.4)', // compatibilidad con autofill / Safari
          },
          
          // === 🎯 VARIANTE “BIG” ===
          // Si el componente tiene la clase personalizada (ej. via InputProps.classes.root = 'bigInput' o 'MuiOutlinedInput-big'),
          // se aplica una versión de mayor altura y menor padding para multiline.
          '&.MuiOutlinedInput-big': {
            height: '17vh',
            maxHeight: '17vh',
            minHeight: '17vh',
            padding: '1vh 1vw',
            lineHeight: '2.1vh',
            alignItems: 'flex-start', // para multiline
            '& .MuiOutlinedInput-inputMultiline': {
              padding: 0, // limpia el padding por defecto
            },
          },
        },
        // El input interno (no el root) también puede recibir estado disabled y esto lo cubre.
        input: {
          fontSize: '1.5vh',
          // y por si acaso el input directo tiene estado disabled
          '&.Mui-disabled': {
            color: 'rgba(166, 166, 166, 0.4)',
            WebkitTextFillColor: 'rgba(166,166,166,0.4)',
          },
        },
      },
    },



    // ======================================================
      // -- BOTONES --
    // ====================================================== 
    MuiButton: {
      styleOverrides: {
        // ======================================================
        // -- ESTILOS COMUNES A TODOS LOS BOTONES --
        // ======================================================
        root: {
          // textTransform: 'none',           // quitar mayúsculas automáticas
          fontSize: '1.35vh',               
          color: "#bfbfbf",
          //borderRadius: '0.5vh',           // radio de borde coherente
          //padding: '0.5vh 1vw',            // espacio interno
        },
    
        // ======================================================
        // -- VARIANTE OUTLINED --
        // ======================================================
        outlined: {
          // color del texto y borde en estado normal
          color: 'var(--border-color-opacity-light)',
          border: '1px solid var(--border-color-opacity-light)',
    
          // hover: borde y fondo sutil
          '&:hover': {
            borderColor: 'var(--border-color-opacity-medium)',
            backgroundColor: 'var(--border-color-opacity-dark)',
          },
    
          // disabled: color y borde atenuados
          '&.Mui-disabled': {
            color: 'rgba(166,166,166,0.4)',
            borderColor: 'var(--border-color-opacity-disabled)',
          },
        },
    
        // ======================================================
        // -- VARIANTE CONTAINED --
        // ======================================================
        contained: {
          // fondo y texto en normal
          //backgroundColor: 'var(--border-color-opacity-light)',
          backgroundColor: 'transparent',
          border: '1px solid var(--border-color-opacity-light)',

          // hover: fondo un poco más oscuro
          '&:hover': {
            backgroundColor: 'var(--border-color-opacity-dark)',
          },
    
          // disabled: fondo atenuado, texto semitransparente
          '&.Mui-disabled': {
            //backgroundColor: 'var(--border-color-opacity-disabled)',
            color: 'var(--border-color-opacity-disabled)',
          },
        },
    
        // ======================================================
        // -- VARIANTE TEXT --
        // ======================================================
        text: {
          // solo texto, sin borde
            color: 'var(--border-color-opacity-medium)',
    
          // hover: fondo muy sutil
          '&:hover': {
            backgroundColor: 'transparent',
            color: 'var(--border-color-opacity-light)',
          },
    
          // disabled: texto tenue
          '&.Mui-disabled': {
            color: 'var(--disabled-color)',
          },
        },
      },
    },


    // ======================================================
      // -- TOOLTIP --
    // ====================================================== 
    MuiTooltip: {
      defaultProps: {
        arrow: true,            // habilita la flecha por defecto
      },
      styleOverrides: {
        // Estilos del contenedor del tooltip
        tooltip: {
          backgroundColor: 'var(--background-default-color)',  // usa tu variable CSS
          border: '1px solid var(--border-color-opacity-medium)',
          color: 'rgba(255,255,255,0.8)',
          fontFamily: 'inherit',
          lineHeight: '1.85vh',
          fontSize: '1.5vh',
        },
        // Estilos de la flecha
        arrow: {
          color: 'var(--background-default-color)',            // mismo fondo que el tooltip
          // su forma se pinta en ::before, ahí metemos el borde
          '&::before': {
            border: '1px solid var(--border-color-opacity-medium)',
          },
        },
      },
    },

  },
});

export default baseTheme;











/* 
Guía rápida de “qué tocar para cambiar X”:

- Cambiar el color del borde normal / hover / focus de un TextField u OutlinedInput: modifica los valores dentro de MuiOutlinedInput -> root -> '& .MuiOutlinedInput-notchedOutline', &:hover .MuiOutlinedInput-notchedOutline, y &.Mui-focused .MuiOutlinedInput-notchedOutline.

- Cambiar el estilo de la variante grande (big): toca el bloque &.MuiOutlinedInput-big en MuiOutlinedInput.styleOverrides.root.

- Modificar el placeholder / label flotante: ajusta MuiInputLabel — el transform para centrar cuando no hay valor y la transformación en &.MuiInputLabel-shrink para cuando flota.

- Cambiar el color del texto deshabilitado en inputs: modifica &.Mui-disabled y &.Mui-disabled .MuiOutlinedInput-input en MuiOutlinedInput.

- Cambiar estilos de Select (valor visible): en MuiSelect.styleOverrides.root tenés fontSize, textAlign, color, etc.

- Cambiar comportamiento del Select cuando está deshabilitado: en MuiSelect.styleOverrides.root los selectores &.Mui-disabled .MuiSelect-select y &.Mui-disabled .MuiSelect-icon.

- Cambiar los items del dropdown: en MuiSelect.defaultProps.MenuProps.PaperProps.sx['& .MuiMenuItem-root'].

- Cambiar label asociada a Select/TextField en estado disabled: en MuiInputLabel.styleOverrides.root['&.Mui-disabled'] (y el fallback '.Mui-disabled &' si el padre está disabled).

*/